import React from "react"
import {
  StripeProvider as StripeElementsProvider,
  Elements,
  injectStripe,
  ReactStripeElements
} from "react-stripe-elements"

import theme from "theme"
import NBInternationalLight from "theme/global-styles/fonts/NBInternationalLight.woff"
import config from "config"

/* The font is not loaded on local environment as https is required. Use ngrok to enable these fonts during development.  */
export const fonts = [
  {
    src: `url(${NBInternationalLight}) format('woff')`,
    family: theme.fonts.paragraph
  }
]

const Context = React.createContext<ReactStripeElements.StripeProps | undefined>(undefined)

const HookProvider: React.FunctionComponent<{
  children: React.ReactNode
  stripe?: ReactStripeElements.StripeProps
}> = ({ children, stripe }) => {
  if (!stripe) throw new Error("Unexpected: stripe not injected.")

  return <Context.Provider value={stripe}>{children}</Context.Provider>
}

const StripeHookProvider = injectStripe(HookProvider)

export const StripeProvider: React.FunctionComponent<{
  children: React.ReactNode
}> = props => (
  <StripeElementsProvider apiKey={config.integrations.stripe.apiKey}>
    <Elements fonts={fonts}>
      <StripeHookProvider>{props.children}</StripeHookProvider>
    </Elements>
  </StripeElementsProvider>
)

export const useStripe = () => React.useContext(Context)
